import { boostBuildPreferences } from './boostBuildPreferences';
import { boostBodyType } from './boostBodyType';
import { getPriceBodyMatch } from './getPriceBodyMatch';

export function getReccomendationsForBuildOnly(
  lastBuildModelName,
  savedBuildBodyTypes,
  buildPriceCategory,
  rankedBodyTypes,
  rankedPriceRanges,
  numberOfReccomendationsNeeded,
) {
  const finalReccomendations = [];
  const alreadySelectedModels = [];

  alreadySelectedModels.push(lastBuildModelName);
  finalReccomendations.push(lastBuildModelName);

  boostBuildPreferences(rankedPriceRanges, buildPriceCategory);
  boostBodyType(savedBuildBodyTypes, rankedBodyTypes);

  const configuratorModelWithBoostSuggestion = getPriceBodyMatch(
    numberOfReccomendationsNeeded,
    rankedPriceRanges,
    rankedBodyTypes,
    alreadySelectedModels,
  );

  finalReccomendations.push(...configuratorModelWithBoostSuggestion);

  return finalReccomendations;
}
